export default __webpack_public_path__ + "static/media/bg2.4122cef5.jpg";